<div class="row g-3">
  <div class="col-sm-12 col-lg-4 form-group mt-4">
    <input type="text" placeholder="Fecha de Inicio" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"
      [(bsValue)]="fechaInicio" [maxDate]="fechaFin" [minDate]="minFechaInicio" readonly>
  </div>
  <div class="col-sm-12 col-lg-4 form-group mt-4">
    <input type="text" placeholder="Fecha Fin" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"
      [(bsValue)]="fechaFin" [minDate]="fechaInicio" readonly>
  </div>
  
  <div class="col-sm-12 col-lg-4 d-flex flex-column align-items-start">
    <button type="button" class="btn btn-outline-primary d-flex justify-content-center align-items-center mb-3 w-100" (click)="ObtenerInformacion()">
      <span class="material-icons me-2">content_paste</span>
      Descargar en Pdf
    </button>
    <button type="button" class="btn btn-outline-primary d-flex justify-content-center align-items-center mb-3 w-100" (click)="ObtenerInformacionForExcel()">
      <span class="material-icons me-2">article</span>
      Descargar en Excel
    </button>
  </div>
</div>

  
  




<div
  class="cuerpo"
  id="cuerpo"
  *ngIf="mostrarEstadoCuenta"
  style="padding: 10px; margin-left: 5px; margin-right: 5px;"
>
  <div
    id="cuerpo1"
    style="
      width: 210mm;
      padding: 10mm;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      position: relative;
      margin: auto;
    "
  >
  <div
  class="cabecera"
  style="
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    border: 2px solid;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
  "
>
  <img
    src="./../../../assets/images/logocoac.png"
    style="
      width: 25%;
      max-width: 150px;
      margin-right: 20px;
    "
    alt="image-whastapp"
  >
  
  <div
    class="texto"
    style="
      text-align: center;
      flex-grow: 1;
    "
  >
    <div
      class="nombre-empresa"
      style="
        font-weight: bold;
        font-size: 15px;
      "
    >
      COOPERATIVA  DE  AHORRO  Y  CRÉDITO  RIOBAMBA  LTDA 
    </div>
    <div
      class="ruc"
      style="
        font-size: 18px;
      "
    >
      0690045389001
    </div>
    <div
      class="estado-cuenta"
      style="
        font-size: 14px;
      "
    >
      ESTADO DE CUENTA
    </div>
    <div
      style="
        font-size: 10px;
      "
    >
      Consulta de movimientos de cuenta del {{fechaInicio | date:'dd-MM-yyyy'}} a {{fechaFin | date:'dd-MM-yyyy'}}
    </div>
  </div>
  
  <img
    src="./../../../assets/images/cosede.png"
    style="
      width: 20%;
      max-width: 150px;
      margin-left: 20px;
    "
    alt="image-whastapp"
  >
</div>

    <div
      class="informacion"
      style="
        font-size: 12px;
        margin-bottom: 10px;
        border-style: solid;
        border-width: 2px;
        padding-top: 6px;
        padding-bottom: 6px;
        display: flex;
        width: 100%;
        max-width: 105%;
      "
    >
      <div class="grupo-info" style="width: 50%; padding: 5px;">
        <div class="columna">
          <div class="etiqueta-info" style="font-weight: 100 ">
            Nombre del Cliente:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            Nombre de la Cuenta:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            Código de Cliente:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            No. de Cuenta:
          </div>
        </div>
      </div>
      <div class="grupo-info" style="width: 50%; padding: 5px;">
        <div class="columna">
          <div
          class="contenedor-dato"
          style="display: flex; align-items: center"
        >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.nombreCliente ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.nombreCuenta || '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.numeroCliente ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.cuenta ?? '-'}}
            </div>
          </div>
        </div>
      </div>
      <div class="grupo-info" style="width: 50%; padding: 5px;">
        <div class="columna">
          <div class="etiqueta-info" style="font-weight: 100">CI:</div>
          <div class="etiqueta-info" style="font-weight: 100">Producto:</div>
          <div class="etiqueta-info" style="font-weight: 100">
            Fecha Apertura:
          </div>
          <div class="etiqueta-info" style="font-weight: 100">
            Fecha Emisión:
          </div>
        </div>
      </div>
      <div class="grupo-info" style="width: 50% ; padding: 5px;">
        <div class="columna">
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.cedula ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{estadoCuenta?.cabeceraEstadoCuenta?.producto ?? '-'}}
            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{ estadoCuenta?.cabeceraEstadoCuenta?.fechaApertura | date:'yyyy-MM-dd' }}

            </div>
          </div>
          <div
            class="contenedor-dato"
            style="display: flex; align-items: center"
          >
            <div style="width: 90%; font-weight: bold; white-space: nowrap">
              {{ currentDate | date:'yyyy-MM-dd'  }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <table
      class="detalle"
      style="width: 100%; margin-bottom: 20px; font-size: 10px; border-collapse: collapse;"
    >
      <thead>
        <tr>
          <th style="border: 1px solid black; padding: 4px ">Fecha Mov.</th>
          <th style="border: 1px solid black; padding: 4px">Sucursal</th>
          <th style="border: 1px solid black; padding: 4px">Asiento</th>
          <th style="border: 1px solid black; padding: 4px">Usuario</th>
          <th style="border: 1px solid black; padding: 4px">Trans</th>
          <th style="border: 1px solid black; padding: 4px; width: 40%">Concepto</th>
          <th style="border: 1px solid black; padding: 4px">Crédito</th>
          <th style="border: 1px solid black; padding: 4px">Débito</th>
          <th style="border: 1px solid black; padding: 4px">Cheq.</th>
          <th style="border: 1px solid black; padding: 4px">Efect.</th>
          <th style="border: 1px solid black; padding: 4px">Contable</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let movimiento of estadoCuenta?.detalleEstadoCuenta ?? []">
          <td style="border: 1px solid black; padding: 4px">{{movimiento.fechaMaquina}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.oficina}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.asiento}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.alias}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.siglas}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.concepto}}</td>
          <td style="border: 1px solid black; padding: 4px">{{!movimiento.esDebito ? (movimiento.valor | currency) : (0 | currency)}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.esDebito ? (movimiento.valor | currency) : (0 | currency)}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.saldoRetencion | currency}}</td>
          <td style="border: 1px solid black; padding: 4px">{{movimiento.saldoCuentaDisponible | currency}}</td>
          <td style="border: 1px solid black; border-right: 1px solid black; padding: 4px">{{movimiento.saldoContable | currency}}</td>
        </tr>
      </tbody>
    </table>
    <div
      class="footer"
      style="
        text-align: center;
        font-size: 12px;
        padding: 10px;
        margin-top: 10px;
      "
    >
    <table style="width: 100%; border-collapse: collapse;">
      <tr>
        <th style="text-align: right; font-size: 12px; vertical-align: bottom;">Saldo Bloqueado:</th>
        <th style="text-align: right; font-size: 12px; vertical-align: bottom;">Saldo Disponible:</th>
        <th style="text-align: right; font-size: 12px; vertical-align: bottom;">Saldo Contable:</th>
      </tr>
      <tr>
        <td style="text-align: right; vertical-align: bottom;">
          <div style="font-size: 10px; font-weight: bold;">{{ estadoCuenta?.saldoBloqueado | currency }}</div>
        </td>
        <td style="text-align: right; vertical-align: bottom;">
          <div style="font-size: 10px; font-weight: bold;">{{ estadoCuenta?.saldoDisponible | currency }}</div>
        </td>
        <td style="text-align: right; vertical-align: bottom;">
          <div style="font-size: 10px; font-weight: bold;">{{ estadoCuenta?.saldoContable | currency }}</div>
        </td>
      </tr>
    </table>
    </div>
  </div>
</div>
